// extracted by mini-css-extract-plugin
export default {"tootlip":"Tooltip_tootlip__6yMTy","tootlip__wrapper":"Tooltip_tootlip__wrapper__2IBc2","tootlip__text":"Tooltip_tootlip__text__thj4b"};